<template>
    <form @submit.prevent="submitForm" novalidate="true" ref="addEditForm">
        <v-card>
            <v-card-title>
                <span class="headline">{{editMode ? 'Редагування' : 'Додавання'}}</span>
            </v-card-title>
            <v-card-text>
                <v-container grid-list-md>
                    <v-layout v-if="!loading" wrap>
                        <v-flex xs12>
                            <v-textarea :error-messages="errors.nameUk"
                                        v-model="form.nameUk"
                                        row-height="3"
                                        label="Назва ІСРС"
                            ></v-textarea>
                        </v-flex>
<!--                        <v-flex xs12>-->
<!--                            <v-textarea :error-messages="errors.nameEn"-->
<!--                                          v-model="form.nameEn"-->
<!--                                        row-height="3"-->
<!--                                        label="Назва ІСРС (english)"-->
<!--                            ></v-textarea>-->
<!--                        </v-flex>-->
                        <v-flex xs12>
                            <v-text-field :error-messages="errors.ectsPoints"
                                          v-model="form.ectsPoints"
                                          @keypress="isNumber($event, 2)"
                                          label="Кількість балів ECTS"
                            ></v-text-field>
                        </v-flex>
                    </v-layout>
                    <loading-placeholder v-else></loading-placeholder>
                </v-container>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-checkbox v-model="createAnother" label="Створити ще одну"></v-checkbox>
                <v-spacer></v-spacer>
                <v-btn
                        color="primary"
                        text
                        @click.native="$emit('shouldCloseAddEdit')"
                        :disabled="loadingSave"
                >Відміна
                </v-btn>
                <v-btn
                        color="primary"
                        type="submit"
                        :loading="loadingSave"
                        :disabled="loadingSave"
                >Зберегти
                </v-btn>
            </v-card-actions>
        </v-card>
    </form>
</template>

<script>
    import HttpService from "../../../HttpService";
    import {remapErrors} from "../../../helpers/errorsHelper";
    import LoadingPlaceholder from "../../common/LoadingPlaceholder";
    import {isNumber} from "../../../helpers/numberHelper";

    export default {
        props: {
            editId: Number,
            editMode: Boolean,
        },
        components: {
            LoadingPlaceholder
        },
        data: () => {
            return {
                form: {
                    nameUk: null,
                    nameEn: null,
                    ectsPoints: 0,
                },
                errors: {
                    nameUk: [],
                    nameEn: [],
                    ectsPoints: [],
                },
                loading: false,
                loadingSave: false,
                createAnother: false,
                isNumber,
            }
        },
        mounted() {
            if (this.editMode) {
                this.loading = true;

                HttpService.getInstance()
                    .get(`individualWorkType/${this.editId}`)
                    .then(resp => {
                        this.loading = false;
                        this.form = resp;
                    })
            }
        },
        watch: {
          "form.orderNumber": function(newOrderNumber) {
              this.form.classNumber = newOrderNumber;
          }  
        },
        methods: {
            submitForm() {
                this.loadingSave = true;

                const additionalParams = {
                    module: {id: this.$route.params.module},
                    department: {id: this.$route.params.department}
                };

                HttpService.getInstance()
                    .post("individualWorkType", {...this.form, ...additionalParams})
                    .then(resp => {
                        this.loadingSave = false;
                        this.$emit("addedEdited", this.createAnother);
                    })
                    .catch(err => {
                        this.loadingSave = false;
                        if (err.errors) {
                            this.errors = remapErrors(err.errors);
                        }
                    });
            },
        }
    }
</script>